import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Curated%20minimalist%20fashion%20flat%20lay%20with%20diverse%20sneakers%20hoodies%20caps%20bags%20and%20streetwear%20accessories%20artistically%20arranged%20on%20warm%20cream%20textured%20surface%2C%20soft%20diffused%20natural%20daylight%2C%20editorial%20product%20photography%20with%20sophisticated%20composition%2C%20warm%20neutral%20aesthetic%2C%20high%20detail%2C%20luxurious%20minimal%20style&width=1600&height=900&seq=cssbuy-hero-main-v4&orientation=landscape"
          alt="CSSBuy Spreadsheet - Produtos verificados e planilhas atualizadas"
          title="CSSBuy Spreadsheet 2026 - Melhor planilha de produtos"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center py-16 md:py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 tracking-tight leading-tight">
          {t('heroTitle')}
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {t('heroSubtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm whitespace-nowrap rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            {t('ctaCssbuySheet')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white text-foreground-900 font-semibold text-sm whitespace-nowrap rounded-md hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            {t('ctaBuyNow')}
          </a>
        </div>
      </div>
    </section>
  );
}